"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const LoadingIndicator_1 = __importDefault(require("../../commonFiles/LoadingIndicator"));
const react_promise_tracker_1 = require("react-promise-tracker");
const react_click_away_listener_1 = __importDefault(require("react-click-away-listener"));
const axios_1 = __importDefault(require("axios"));
const URLs_1 = require("../utility/URLs");
function SelectWithApiSearch(props) {
    const setSelectedValue = props.setSelectedValue;
    const label = props.label;
    const paginationEndpoint = props.paginationEndpoint;
    const valueKeyWord = props.valueKeyWord;
    const nameKeyWord = props.nameKeyWord;
    const searchKeyWord = props.searchKeyWord;
    const value = props.value;
    const setSelectedValueObject = props.setSelectedValueObject;
    const [endpointOptions, setendpointOptions] = react_1.default.useState();
    const [next_page_url, setnext_page_url] = react_1.default.useState();
    const [randomStr, setrandomStr] = react_1.default.useState(Math.random().toString(36).slice(2, 7));
    const page_size = 30;
    react_1.default.useEffect(() => {
        (0, react_promise_tracker_1.trackPromise)((0, URLs_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return paginationEndpoint({ page_size: page_size }); }), (responsedata) => {
            // console.log('searchInputChange responsedata', responsedata)
            setendpointOptions(oldData => [...responsedata.data]);
            setnext_page_url(responsedata.next_page_url);
        }, 'SelectWithApiSearch useEffect', true), randomStr);
    }, [paginationEndpoint]);
    function searchInputChange(q) {
        (0, react_promise_tracker_1.trackPromise)((0, URLs_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return paginationEndpoint({ [searchKeyWord !== null && searchKeyWord !== void 0 ? searchKeyWord : nameKeyWord]: q, page_size: page_size }); }), (responsedata) => {
            // console.log('searchInputChange responsedata', responsedata)
            setendpointOptions(oldData => [...responsedata.data]);
            setnext_page_url(responsedata.next_page_url);
        }, 'SelectWithApiSearch searchInputChange', true), randomStr);
    }
    const handleScroll = (e) => __awaiter(this, void 0, void 0, function* () {
        const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 4;
        if (bottom && next_page_url) {
            (0, react_promise_tracker_1.trackPromise)((0, URLs_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return axios_1.default.get(next_page_url); }), (data) => {
                setendpointOptions(oldData => [...oldData, ...data.data]);
                setnext_page_url(data.next_page_url);
            }, 'SelectWithApiSearch handleScroll', true), randomStr);
        }
    });
    react_1.default.useEffect(() => {
        // if (paginationEndpoint)
        //     console.log('SelectWithApiSearch endpointOptions', endpointOptions)
    }, [endpointOptions]);
    function selectedOption() {
        const fromloadedOptions = endpointOptions === null || endpointOptions === void 0 ? void 0 : endpointOptions.find(option => option[valueKeyWord !== null && valueKeyWord !== void 0 ? valueKeyWord : 'value'] == value);
        if (!fromloadedOptions) {
            // return { [nameKeyWord ?? 'name']: value }
        }
        return fromloadedOptions;
    }
    function selectedOptionForValue(value) {
        if (value)
            return endpointOptions === null || endpointOptions === void 0 ? void 0 : endpointOptions.find(option => option[valueKeyWord !== null && valueKeyWord !== void 0 ? valueKeyWord : 'value'] == value);
    }
    const [display, setdisplay] = react_1.default.useState('none');
    return (react_1.default.createElement(react_click_away_listener_1.default, { onClickAway: () => { setdisplay('none'); } },
        react_1.default.createElement("div", { className: 'dropdown' },
            react_1.default.createElement("div", { className: 'bg-white border p-2 rounded', onClick: () => { setdisplay(display == 'block' ? 'none' : 'block'); } }, selectedOption() ? selectedOption()[nameKeyWord !== null && nameKeyWord !== void 0 ? nameKeyWord : 'name'] : (label)),
            react_1.default.createElement("div", { className: 'dropdown-content', style: { display: display } },
                react_1.default.createElement("input", { type: 'text', className: 'form-control mb-1', onChange: e => { searchInputChange(e.target.value); }, placeholder: label }),
                react_1.default.createElement("select", { className: "form-control", onChange: (e) => {
                        setSelectedValue(e.target.value);
                        if (setSelectedValueObject)
                            setSelectedValueObject(selectedOptionForValue(e.target.value));
                        setdisplay('none');
                    }, size: 5, value: value !== null && value !== void 0 ? value : '', onScroll: handleScroll },
                    react_1.default.createElement("option", { value: undefined }, ''), endpointOptions === null || endpointOptions === void 0 ? void 0 :
                    endpointOptions.map((option, index) => (react_1.default.createElement("option", { key: index, value: option[valueKeyWord !== null && valueKeyWord !== void 0 ? valueKeyWord : 'value'] }, option[nameKeyWord !== null && nameKeyWord !== void 0 ? nameKeyWord : 'name'])))),
                react_1.default.createElement(LoadingIndicator_1.default, { area: randomStr })))));
}
exports.default = SelectWithApiSearch;
